export const formatAttendanceRuleType = (type) => {
	let formattedType = "";

    switch(type) {
        case 'late':
            formattedType = "Late";
            break;
        case 'undertime':
            formattedType = "Undertime";
            break;
        case 'absent':
            formattedType = "Absent";
            break;
        case 'overtime':
            formattedType = "Overtime";
            break;
        case 'nightShift':
            formattedType = "Night Shift Diff";
            break;  
        default:
            formattedType = type;
    }

	return formattedType;
}

export const formatAttendanceRuleCalculationType = (calculationType) => {
	let formattedType = "";

    switch(calculationType) {
        case 'noDeduction':
            formattedType = "No deduction";
            break;
        case 'deductPerMinute':
            formattedType = "Deduct per minute";
            break;
        case 'multiplicator':
            formattedType = "Multiplicator";
            break;
        case 'noAddition':
            formattedType = "No Addition";
            break;
        case 'addPerMinute':
            formattedType = "Add Per Minute";
            break;  
        default:
            formattedType = calculationType;
    }

	return formattedType;
}